<template>
  <div class="sectionPage">
    <div class="bgBlock">
      <img class="sectionBg" :src="img">
    </div>
    <div class="content">
      <img class="mIcon mShow" :src="icon">
      <p class="title pcShow">{{content.title}}</p>
      <p class="title mShow">{{mTitle}}</p>
      <div class="shortLine"></div>
      <p v-if="content.boldText" class="text bold">{{content.boldText}}</p>
      <p class="text">{{content.text}}</p>
      <div class="btnBlock mShow">
        <Btn :btn="btn" :type="content.componentsType.mobile" />
        <Btn class="secondBtn" v-if="hasContinueBtn" type="continueBtn" />
      </div>
      <div class="btnBlock pcShow">
        <Btn :btn="btn" :type="content.componentsType.pc" />
        <Btn class="secondBtn" v-if="hasContinueBtn" type="continueBtn" />
      </div>
      
    </div>
  </div>
</template>

<script>
import Btn from '@/components/Btn.vue'
export default {
  name: "SectionPage",
  props: {
    img: String,
    content: Object,
    btn: Object,
    hasContinueBtn: Boolean,
    icon: String
  },
  components: {
    Btn,
  },
  computed:{
    mTitle(){
      return this.$route.name.indexOf('section') !== -1? this.content.title.slice(3): this.content.title
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media only screen and (min-width: 767px) {
  .text {
    font-size: 18px;
    color: black;
    line-height: 24px;
    padding-bottom: 30px;
  }
  .shortLine {
    width: 38px;
    margin-top: 14px;
    margin-bottom: 37px;
    border-bottom: 2px solid black;
  }
  p {
    margin: 0;
  }
}
.sectionPage{
  display: flex;
  .bgBlock{
    width: 60%;
    height: 100vh;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    .sectionBg{
      height: 100%;
      min-height: 60vw;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    width: 40%;
    padding-left: 50px;
    padding-right: 10%;
    .mIcon{
      margin-top: 34px;
      width: 40px;
    }
    .title{
      font-size: 42px;
      line-height: 50px;
      font-weight: bold;
      white-space: pre-wrap;
      color: black;
    }
    .btnBlock{
      display: flex;
      .secondBtn{
        margin-left: 60px;
      }
    }
  }
}
@media only screen and (max-width: 767px){
  .sectionPage{
    flex-direction: column;
    .text {
      color: black;
      font-size: 14px;
      line-height: 18px;
      padding-bottom: 20px;
    }
    .shortLine {
      width: 20px;
      margin-bottom: 13px;
      margin-top: 13px;
      border-bottom: 2px solid black
    }
    p {
      margin-bottom: 0px;
    }
    .bgBlock{
      width: 100%;
      height: 50vh;
      .sectionBg{
        height: 100%;
        min-height: 100vw;
      }
    }
    .content{
      width: 100%;
      align-items: center;
      padding-bottom: 50px;
      .title{
        margin-top: 15px;
        text-align: center;
        font-size: 22px;
        color: black;
        line-height: 25px;
      }
      p{
      text-align: center;
      }
      .btnBlock{
        flex-direction: column;
        .secondBtn{
          margin-left: 0;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
